import { render, staticRenderFns } from "./Kalender.vue?vue&type=template&id=18ff2fc4&scoped=true&"
import script from "./Kalender.vue?vue&type=script&lang=js&"
export * from "./Kalender.vue?vue&type=script&lang=js&"
import style0 from "./Kalender.vue?vue&type=style&index=0&id=18ff2fc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/zeitkontrolle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ff2fc4",
  null
  
)

export default component.exports